<template>
  <div class="page-footer">
    <div class="body-width">
      <!-- 功能区 -->
      <div class="footer-section functional-section">
        <div class="contact-section">
          <div class="logo m-b-19">
            <img
              style="height: 24px"
              :src="require('@/assets/images/logo-white.png')"
            />
          </div>
          <p>联系电话：{{ global.phone }}</p>
          <p>邮箱地址：{{ global.email }}</p>
          <p>工作时间（工作日）：{{ global.workTime }}</p>
        </div>
        <div class="vertical-line">
          <a-divider
            type="vertical"
            style="height: 100%; background: #fff; opacity: 0.1; margin: 0 74px"
          />
        </div>

        <div class="functional-list">
          <div
            v-for="item in functionalList"
            :key="item.title"
            class="functional-item"
          >
            <div class="functional-item-title">{{ item.title }}</div>
            <div class="functional-sub-list">
              <p
                v-for="subItem in item.list"
                :key="subItem.label"
                class="functional-sub-item"
                @click="toUrl(subItem.url, subItem.routeMode)"
              >
                {{ subItem.label }}
              </p>
            </div>
          </div>
          <div class="functional-item">
            <div class="functional-item-title">扫码获取商机</div>
            <img
              style="width: 84px; height: 84px"
              :src="require('@/assets/images/wx-public-qrcode.jpg')"
            />
          </div>
        </div>
      </div>
      <a-divider style="background: #fff; opacity: 0.1" />
      <!-- 版权区 -->
      <div class="footer-section link-section">
        <div class="link-list">
          <span class="link-label">友情链接</span>
          <span
            v-for="item in linkList"
            :key="item.label"
            class="link-item"
            @click="toUrl(item.url)"
          >
            {{ item.label }}
          </span>
        </div>
        <div class="copyright m-t-24">
          Copyright©2017-{{ currentYear }} 精彩纵横 版权所有
          <span class="link-item" @click="toUrl('https://beian.miit.gov.cn/')">
            赣ICP备17007647号-6
          </span>
          赣B2-20180066
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { addQueryToUrl, globalVar } from '@/utils/common'

import { mapState } from 'vuex'
import { routes, useRoute } from '@/router'

export default {
  name: 'PageFooter',

  data() {
    return {
      global: globalVar(),

      // 友情链接列表
      linkList: [
        { label: '江西省咨询投资集团有限公司', url: 'http://www.jxzxtz.com' },
        {
          label: '江西省机电设备招标有限公司',
          url: 'http://www.jxbidding.com'
        },
        { label: '广西机电设备招标有限公司', url: 'http://www.gxbidding.com' }
      ]
    }
  },

  computed: {
    ...mapState('system', ['systemTime', 'platformDomain']),

    currentYear() {
      const current = new Date(this.systemTime)

      return current.getFullYear()
    },

    functionalList() {
      console.log('哈喽：', this.platformDomain)
      return [
        {
          title: '关于我们',
          list: [
            {
              label: '公司介绍',
              url: `${this.platformDomain.portal}/about`
            },
            {
              label: '公司新闻',
              url: `${this.platformDomain.portal}/about/news`
            },
            {
              label: '联系我们',
              url: `${this.platformDomain.portal}/about/contact`
            }
          ]
        },
        {
          title: '标前狗',
          list: routes
            .filter((item) => item.meta?.inNavbar)
            .map((item) => {
              return {
                label: item.meta?.title,
                url: item.path,
                routeMode: true
              }
            })
        },
        {
          title: '解决方案',
          list: [
            {
              label: '招标和非招标采购',
              url: `${this.platformDomain.portal}/solutions/tender/solution`
            },
            {
              label: '物资处置',
              url: `${this.platformDomain.portal}/solutions/material/solution`
            }
          ]
        },
        {
          title: '服务与支持',
          list: [
            {
              label: '帮助专区',
              url: `${this.platformDomain.portal}/help`
            }
          ]
        }
      ]
    }
  },

  created() {
    this.$store.dispatch('system/getSystemTime')
  },

  methods: {
    /**
     * 页面跳转
     * @param {String} url 跳转地址
     * @param {Boolean} routeMode 使用路由模式，仅站内页面使用
     */
    toUrl(url, routeMode = false) {
      if (routeMode) {
        const currentPath = useRoute()
        if (currentPath.path === url) return
        this.$router.push({
          path: url
        })
      } else {
        window.open(addQueryToUrl(url), '_blank')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-footer {
  width: 100%;
  background-color: $text-color;
  color: $text-third-color;
  font-size: 12px;

  .footer-section {
    padding: 32px 0;

    p {
      margin-bottom: 16px;
    }

    &.functional-section {
      display: flex;
      align-items: stretch;

      .functional-list {
        display: flex;
        align-items: stretch;
        flex: 1;
        justify-content: space-between;

        .functional-item {
          .functional-item-title {
            font-size: 14px;
            color: $white-color;
            margin-bottom: 24px;
          }

          .functional-sub-list {
            .functional-sub-item {
              cursor: pointer;

              &:hover {
                color: $white-color;
              }
            }
          }
        }
      }
    }

    &.link-section {
      .link-list {
        .link-label {
          color: $white-color;
          margin-right: 24px;
        }
      }

      .link-item {
        cursor: pointer;

        &:not(:last-child) {
          margin-right: 24px;
        }

        &:hover {
          color: $white-color;
        }
      }
    }
  }
}

.logo {
  display: flex;
  align-items: center;

  .version-tag {
    padding: 4px 8px;
    background-color: $text-second-color;
    border-radius: 2px;
    color: $white-color;
    font-size: 12px;
    margin-left: 10px;
  }
}
</style>
